import React from 'react'
import { Input, Label } from 'reactstrap'
import { FaCloudUploadAlt, FaFileAlt } from 'react-icons/fa'

export const FileUpload = ({
  onChange,
  className,
  id,
  children = 'Selecione un archivo...',
  value,
  name,
  invalid,
  error,
  accept,
}) => {
  return (
    <div>
      <Label
        htmlFor={id}
        style={{
          margin: 'auto 0',
          padding: '1rem',
          borderRadius: '4px',
          border: '1px solid #30D26E',
          background: '#30D26E',
          opacity: '0.8',
          transition: '.5s',
          display: 'flex',
          gap: '1rem',
          color: 'white',
          cursor: 'pointer',
          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
        }}
      >
        {!!value ? (
          <FaFileAlt style={{ margin: 'auto 0', color: 'white' }} />
        ) : (
          <FaCloudUploadAlt style={{ margin: 'auto 0', color: 'white' }} />
        )}
        {children}
      </Label>
      <Input
        id={id}
        type='file'
        onChange={onChange}
        style={{ display: 'none' }}
        className={className}
        name={name}
        invalid={invalid}
        accept={accept}
      />
      <div className='invalid-feedback'>{error}</div>
    </div>
  )
}
